<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2001</span></div>
    </div>
    <div class="view-wrap yr2002">


<!--<StatsFlex qbRating='94.8' completions='15' yards='221' touchdowns='1'></StatsFlex>-->

<FullYearStats fullGames='1' fullCompletions='15' fullAttempts='27' fullYards='221' fullPct='55.6' fullTDs='1' fullINTs='0' fullYPG='221.0' fullRating='94.8'></FullYearStats>


  
  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      
      <div class="year-summary-text-flex">

      <h1 class="content-headline">Brees learns behind Flutie</h1>


      <p class="image-paragraph">
      Brees was drafted with the 1st pick in the second round of the 2001 NFL draft, "mainly to back up Doug Flutie," Brees reflected. Coming off a 1-15 season in 2000, the Chargers had plenty of room to grow.<br/><br/>


        <img src="../assets/brees-2001-top-image.jpg" alt="Drew Brees in 2001 - Image" style="width:100%;">
        
       
      </p>


      <p>
      After starting the season 5-2, Flutie went down with a concussion against the Chiefs. Brees would take his first professional snaps, eventually mounting a 4th quarter comeback and topping it off with his first TD pass of his career, a 20 yard strike to Freddie Jones with 6 minutes left. The Chargers defense wasn't able to hold and Brees wasn't able to take it 72 yards in the last minute, losing 25-20.<br/><br/>

      Flutie would return as the starter for the rest of the season, but the Chargers weren't able to win again, losing 9 straight to close out the year.<br/><br/>

      <a href="https://youtu.be/xv-9kz4XBeA" class="youtube-external-link" target="_blank">
        WATCH: 9 for No. 9 - A Champions Journey - Chapter 3: Going Pro
      </a><br/><br/>
       
      </p>






     
  
      </div> <!--end text-flex-->
    </div>
  </div>



   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">Big Ten All Time Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>


</div>


<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2001 Touchdown Tally"> 2001 TOUCHDOWN TALLY</h1>
</div>

<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2001 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2001 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2001 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2001 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2001 - Slide5"></div>
</flickity>

<!-- if you don't want to use the buttons Flickity provides -->
<!--<button @click="previous()">Custom Previous Button</button>
<button @click="next()">Custom Next Button</button>
<br/><br/>
<button @click="resize()">RESIZE</button>-->


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2002">2002»</router-link></div>
</div>

<!--<button v-on:click="resize()" ref="resizeBtn">resize</button>-->


    </div>
  </div>
</template>






<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2001',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2001 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      dataCollection: {},
      dataOptions:{},
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2001-top.jpg",
      image1: "brees-2001-slide-1.jpg",
      image2: "brees-2001-slide-2.jpg",
      image3: "brees-2001-slide-3.jpg",
      image4: "brees-2001-slide-4.jpg",
      image5: "brees-2001-slide-5.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true,
            lazyLoad: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {


     myClickEvent($event) {
            const elem = this.$refs.resizeBtn
            elem.click()
        },
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2001;
      console.log(this.tds)
    },

    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    },
    logme() {
      console.log("This is finally working!")
    }
  },

  mounted() {

    setTimeout(() => {
    this.$refs.flickity.resize();
}, 2000)
    
      
    
      console.log("This.resize was fired but did nothing")

    this.getTDs();

  },

  beforeMount() {



  },


    created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#000000",
        "borderColor": "#C28E0E",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 1026,
                  y: 11792,
                  r: 90/3
                }
              ]
      },
      {
        "label": "J.T. Barrett",
        "backgroundColor": "#bb0000",
        "borderColor": "#666666",
        "fill": false,
        radius: 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 769,
                  y: 9434,
                  r: 104/3
                }
              ]
      },
      {
        "label": "Chad Henne",
        "backgroundColor": "#ffcb05",
        "borderColor": "#00274c",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 828,
                  y: 9715,
                  r: 87/3
                }
              ]
      },
      {
        "label": "Curtis Painter",
        "backgroundColor": "#C28E0E",
        "borderColor": "#000000",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 987,
                  y: 11163,
                  r: 67/3
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' YARDS, ' + tooltipItem.xLabel.toLocaleString() + ' Completions, ' + rLabel*3 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Career Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Career Completions'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }

}
</script>

<style>




</style>


// WEBPACK FOOTER //
// src/views/yr2001.vue